const today = new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
const dueDate30 = new Date(Date.now() + 30 * 86400000).toLocaleDateString('en-US', {
  year: 'numeric', month: 'long', day: 'numeric',
});

const baseInvoiceStyles = `
  * { box-sizing: border-box; }
  body { font-family: Arial, sans-serif; color: #1a1a1a; margin: 0; padding: 40px; font-size: 13px; line-height: 1.6; background: #fff; }
  h2 { font-size: 15px; font-weight: 700; border-bottom: 2px solid #1a1a1a; padding-bottom: 6px; margin-top: 32px; margin-bottom: 12px; }
  h3 { font-size: 13px; font-weight: 700; margin: 0 0 4px; }
  table { width: 100%; border-collapse: collapse; margin-top: 10px; }
  th { background: #f3f4f6; text-align: left; padding: 9px 11px; font-size: 12px; border: 1px solid #e5e7eb; font-weight: 700; }
  td { padding: 9px 11px; border: 1px solid #e5e7eb; font-size: 12px; vertical-align: middle; }
  .header { display: flex; justify-content: space-between; align-items: flex-start; margin-bottom: 32px; border-bottom: 3px solid #1a1a1a; padding-bottom: 20px; }
  .company-info { font-size: 11px; color: #6b7280; line-height: 1.7; }
  .lbl { font-size: 10px; color: #6b7280; text-transform: uppercase; letter-spacing: 0.6px; margin-bottom: 2px; }
  .val { font-size: 13px; font-weight: 700; }
  .highlight { background: #f9fafb; padding: 14px 16px; border-left: 3px solid #1a1a1a; border-radius: 0 4px 4px 0; margin: 12px 0; }
  .badge { display: inline-block; background: #1a1a1a; color: #fff; padding: 3px 12px; border-radius: 4px; font-size: 11px; font-weight: 700; }
  .tr-total td { font-weight: 700; background: #f3f4f6; }
  .invoice-word { font-size: 32px; font-weight: 900; letter-spacing: -1px; color: #1a1a1a; }
  .meta-row { display: flex; gap: 48px; margin-bottom: 28px; flex-wrap: wrap; }
  .meta-block { min-width: 100px; }
  .right-align { text-align: right; }
  .note { font-size: 11px; color: #9ca3af; margin-top: 20px; }
`;

const editModeStyles = `
  .e {
    outline: none;
    border-radius: 3px;
    cursor: text;
    min-width: 12px;
    display: inline-block;
    transition: background 0.15s, outline 0.15s;
    background: rgba(254, 243, 199, 0.55);
    border-bottom: 1.5px dashed #d97706;
    padding: 0 2px;
  }
  .e:hover { background: rgba(253, 230, 138, 0.75); outline: 1px solid #d97706; }
  .e:focus { background: rgba(253, 230, 138, 0.9); outline: 2px solid #d97706; border-bottom: none; }
  .e:empty:before { content: attr(data-ph); color: #b45309; pointer-events: none; font-style: italic; }
  td.e { display: table-cell; }
  .hint-bar {
    position: fixed; top: 10px; left: 50%; transform: translateX(-50%);
    background: #92400e; color: white; padding: 6px 20px; border-radius: 20px;
    font-size: 12px; z-index: 9999; pointer-events: none; font-family: Arial, sans-serif;
    box-shadow: 0 2px 8px rgba(146,64,14,0.35);
  }
`;

const calcScript = `
<script>
  function fmtMoney(n) { return '$' + parseFloat(n || 0).toFixed(2); }
  function calc() {
    var sub = 0;
    document.querySelectorAll('.lr').forEach(function(row) {
      var qEl = row.querySelector('.qty');
      var pEl = row.querySelector('.prc');
      var qty = parseFloat((qEl ? qEl.textContent : '0').replace(/[^0-9.]/g,'')) || 0;
      var prc = parseFloat((pEl ? pEl.textContent : '0').replace(/[^0-9.]/g,'')) || 0;
      var amt = qty * prc;
      sub += amt;
      var ac = row.querySelector('.amt-cell');
      if (ac) ac.textContent = fmtMoney(amt);
    });
    var taxEl = document.getElementById('f_taxr');
    var taxRate = parseFloat((taxEl ? taxEl.textContent : '0').replace(/[^0-9.]/g,'')) || 0;
    var taxAmt = sub * taxRate / 100;
    var total = sub + taxAmt;
    var s = document.getElementById('f_subtotal'); if (s) s.textContent = fmtMoney(sub);
    var td = document.getElementById('f_taxd');    if (td) td.textContent = taxRate + '%';
    var ta = document.getElementById('f_taxa');    if (ta) ta.textContent = fmtMoney(taxAmt);
    var tl = document.getElementById('f_total');   if (tl) tl.textContent = fmtMoney(total);
  }
  document.querySelectorAll('.qty, .prc, #f_taxr').forEach(function(el) {
    el.addEventListener('input', calc);
  });
  calc();
<\/script>`;

/** Builds a fully editable invoice HTML document rendered inside an iframe */
export const buildEditableInvoiceHtml = (): string => `<!DOCTYPE html>
<html>
<head>
<meta charset="utf-8">
<title>Invoice Editor</title>
<style>${baseInvoiceStyles}${editModeStyles}</style>
</head>
<body>
<div class="hint-bar">✏️ Yellow fields = fill these in &nbsp;·&nbsp; Click any yellow field to type &nbsp;·&nbsp; Amounts auto-calculate</div>

<!-- ── Header ── -->
<div class="header">
  <div>
    <div class="invoice-word">INVOICE</div>
    <div style="font-size:11px;color:#6b7280;margin-top:5px">
      <span class="e" contenteditable="true" id="f_invoice_number" data-ph="INV-2026-001">INV-2026-001</span>
    </div>
  </div>
  <div class="right-align">
    <h3 style="font-size:16px;margin:0 0 5px" class="e" contenteditable="true" id="f_your_company" data-ph="Your Company Name">Your Company Name</h3>
    <div class="company-info">
      <span class="e" contenteditable="true" id="f_your_address" data-ph="123 Main St, City, State ZIP">123 Main St, City, State ZIP</span><br>
      <span class="e" contenteditable="true" id="f_your_email" data-ph="billing@yourcompany.com">billing@yourcompany.com</span><br>
      <span class="e" contenteditable="true" id="f_your_phone" data-ph="(555) 000-0000">(555) 000-0000</span>
    </div>
  </div>
</div>

<!-- ── Meta row ── -->
<div class="meta-row">
  <div class="meta-block">
    <div class="lbl">Bill To</div>
    <h3 class="e" contenteditable="true" id="f_client_name" data-ph="Client Name">Client Name</h3>
    <div class="company-info">
      <span class="e" contenteditable="true" id="f_client_address" data-ph="456 Client St, City, State">456 Client St, City, State</span><br>
      <span class="e" contenteditable="true" id="f_client_email" data-ph="client@email.com">client@email.com</span>
    </div>
  </div>
  <div class="meta-block">
    <div class="lbl">Invoice Date</div>
    <div class="val e" contenteditable="true" id="f_invoice_date" data-ph="${today}">${today}</div>
  </div>
  <div class="meta-block">
    <div class="lbl">Due Date</div>
    <div class="val e" contenteditable="true" id="f_due_date" data-ph="${dueDate30}">${dueDate30}</div>
  </div>
  <div class="meta-block">
    <div class="lbl">Status</div>
    <div><span class="badge">UNPAID</span></div>
  </div>
</div>

<!-- ── Services table ── -->
<h2>Services Rendered</h2>
<table>
  <tr>
    <th style="width:46%">Description</th>
    <th style="width:14%">Qty / Hrs</th>
    <th style="width:18%">Unit Price ($)</th>
    <th style="width:22%">Amount</th>
  </tr>
  <tr class="lr">
    <td class="e" contenteditable="true" data-ph="Service or product description">Service description</td>
    <td class="e qty" contenteditable="true" data-ph="1">1</td>
    <td class="e prc" contenteditable="true" data-ph="0.00">0.00</td>
    <td class="amt-cell" style="color:#1a1a1a;font-weight:500">$0.00</td>
  </tr>
  <tr class="lr">
    <td class="e" contenteditable="true" data-ph="Service or product description"></td>
    <td class="e qty" contenteditable="true" data-ph="1"></td>
    <td class="e prc" contenteditable="true" data-ph="0.00"></td>
    <td class="amt-cell" style="color:#6b7280">—</td>
  </tr>
  <tr class="lr">
    <td class="e" contenteditable="true" data-ph="Service or product description"></td>
    <td class="e qty" contenteditable="true" data-ph="1"></td>
    <td class="e prc" contenteditable="true" data-ph="0.00"></td>
    <td class="amt-cell" style="color:#6b7280">—</td>
  </tr>
  <tr class="lr">
    <td class="e" contenteditable="true" data-ph="Service or product description"></td>
    <td class="e qty" contenteditable="true" data-ph="1"></td>
    <td class="e prc" contenteditable="true" data-ph="0.00"></td>
    <td class="amt-cell" style="color:#6b7280">—</td>
  </tr>
  <tr class="lr">
    <td class="e" contenteditable="true" data-ph="Service or product description"></td>
    <td class="e qty" contenteditable="true" data-ph="1"></td>
    <td class="e prc" contenteditable="true" data-ph="0.00"></td>
    <td class="amt-cell" style="color:#6b7280">—</td>
  </tr>
  <!-- Totals -->
  <tr>
    <td colspan="3" class="right-align" style="color:#6b7280;font-size:11px">Subtotal</td>
    <td id="f_subtotal" style="font-weight:600">$0.00</td>
  </tr>
  <tr>
    <td colspan="2" class="right-align" style="color:#6b7280;font-size:11px">Tax Rate (%)</td>
    <td style="text-align:center">
      <span class="e qty" contenteditable="true" id="f_taxr" data-ph="0">0</span>%
    </td>
    <td id="f_taxa" style="color:#6b7280">$0.00</td>
  </tr>
  <tr class="tr-total">
    <td colspan="3" class="right-align">TOTAL DUE</td>
    <td id="f_total" style="font-size:14px">$0.00</td>
  </tr>
</table>

<!-- ── Payment info ── -->
<h2>Payment Information</h2>
<div class="highlight">
  <span class="e" contenteditable="true" id="f_payment_info" data-ph="Bank: Chase | Account: XXXX | Routing: XXXX | Zelle: phone@email.com">
    Bank: Chase | Account: XXXX | Routing: XXXX
  </span>
</div>

<p class="note">Payment is due within 30 days. Late payments are subject to a 1.5% monthly fee. Thank you for your business!</p>

${calcScript}
</body>
</html>`;

/** Extract current values from a live iframe document */
export const extractInvoiceData = (iframeDoc: Document): Record<string, string> => {
  const data: Record<string, string> = {};

  // Named fields
  iframeDoc.querySelectorAll('[id^="f_"]').forEach((el) => {
    const key = (el as HTMLElement).id.slice(2); // strip "f_"
    data[key] = el.textContent?.trim() || '';
  });

  // Line items
  iframeDoc.querySelectorAll('.lr').forEach((row, i) => {
    const cells = row.querySelectorAll('td');
    data[`item${i + 1}_desc`]  = cells[0]?.textContent?.trim() || '';
    data[`item${i + 1}_qty`]   = cells[1]?.textContent?.trim() || '';
    data[`item${i + 1}_price`] = cells[2]?.textContent?.trim() || '';
  });

  return data;
};

const esc = (s: string) =>
  s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');

const fmtMoney = (n: number) => '$' + n.toFixed(2);

/** Build a clean, print-ready invoice HTML from extracted data */
export const buildCleanInvoiceHtml = (data: Record<string, string>): string => {
  const rows: string[] = [];
  let subtotal = 0;

  for (let i = 1; i <= 5; i++) {
    const desc = data[`item${i}_desc`]?.trim();
    if (!desc) continue;
    const qty = parseFloat((data[`item${i}_qty`] || '1').replace(/[^0-9.]/g, '')) || 1;
    const price = parseFloat((data[`item${i}_price`] || '0').replace(/[^0-9.]/g, '')) || 0;
    const amount = qty * price;
    subtotal += amount;
    rows.push(`<tr>
      <td>${esc(desc)}</td>
      <td>${esc(data[`item${i}_qty`] || '1')}</td>
      <td>${fmtMoney(price)}</td>
      <td>${fmtMoney(amount)}</td>
    </tr>`);
  }

  const taxRate = parseFloat((data['taxr'] || '0').replace(/[^0-9.]/g, '')) || 0;
  const taxAmt = subtotal * taxRate / 100;
  const total = subtotal + taxAmt;

  return `<!DOCTYPE html>
<html>
<head>
<meta charset="utf-8">
<title>Invoice ${esc(data['invoice_number'] || '')}</title>
<style>
  * { box-sizing: border-box; }
  body { font-family: Arial, sans-serif; color: #1a1a1a; margin: 0; padding: 40px; font-size: 13px; line-height: 1.6; background: #fff; }
  h2 { font-size: 15px; font-weight: 700; border-bottom: 2px solid #1a1a1a; padding-bottom: 6px; margin-top: 32px; margin-bottom: 12px; }
  h3 { font-size: 13px; font-weight: 700; margin: 0 0 4px; }
  table { width: 100%; border-collapse: collapse; margin-top: 10px; }
  th { background: #f3f4f6; text-align: left; padding: 9px 11px; font-size: 12px; border: 1px solid #e5e7eb; font-weight: 700; }
  td { padding: 9px 11px; border: 1px solid #e5e7eb; font-size: 12px; vertical-align: middle; }
  .header { display: flex; justify-content: space-between; align-items: flex-start; margin-bottom: 32px; border-bottom: 3px solid #1a1a1a; padding-bottom: 20px; }
  .co-info { font-size: 11px; color: #6b7280; line-height: 1.7; }
  .lbl { font-size: 10px; color: #6b7280; text-transform: uppercase; letter-spacing: 0.6px; margin-bottom: 2px; }
  .val { font-size: 13px; font-weight: 700; }
  .highlight { background: #f9fafb; padding: 14px 16px; border-left: 3px solid #1a1a1a; border-radius: 0 4px 4px 0; margin: 12px 0; font-size: 12px; }
  .badge { display: inline-block; background: #1a1a1a; color: #fff; padding: 3px 12px; border-radius: 4px; font-size: 11px; font-weight: 700; }
  .tr-total td { font-weight: 700; background: #f3f4f6; }
  .invoice-word { font-size: 32px; font-weight: 900; letter-spacing: -1px; color: #1a1a1a; }
  .meta-row { display: flex; gap: 48px; margin-bottom: 28px; flex-wrap: wrap; }
  .meta-block { min-width: 100px; }
  .note { font-size: 11px; color: #9ca3af; margin-top: 20px; }
</style>
</head>
<body>

<div class="header">
  <div>
    <div class="invoice-word">INVOICE</div>
    <div style="font-size:11px;color:#6b7280;margin-top:5px">${esc(data['invoice_number'] || '')}</div>
  </div>
  <div style="text-align:right">
    <h3 style="font-size:16px;margin:0 0 5px">${esc(data['your_company'] || '')}</h3>
    <div class="co-info">
      ${esc(data['your_address'] || '')}<br>
      ${esc(data['your_email'] || '')}<br>
      ${esc(data['your_phone'] || '')}
    </div>
  </div>
</div>

<div class="meta-row">
  <div class="meta-block">
    <div class="lbl">Bill To</div>
    <h3>${esc(data['client_name'] || '')}</h3>
    <div class="co-info">
      ${esc(data['client_address'] || '')}<br>
      ${esc(data['client_email'] || '')}
    </div>
  </div>
  <div class="meta-block">
    <div class="lbl">Invoice Date</div>
    <div class="val">${esc(data['invoice_date'] || '')}</div>
  </div>
  <div class="meta-block">
    <div class="lbl">Due Date</div>
    <div class="val">${esc(data['due_date'] || '')}</div>
  </div>
  <div class="meta-block">
    <div class="lbl">Status</div>
    <span class="badge">UNPAID</span>
  </div>
</div>

<h2>Services Rendered</h2>
<table>
  <tr>
    <th style="width:46%">Description</th>
    <th style="width:14%">Qty / Hrs</th>
    <th style="width:18%">Unit Price</th>
    <th style="width:22%">Amount</th>
  </tr>
  ${rows.join('\n')}
  <tr>
    <td colspan="3" style="text-align:right;color:#6b7280;font-size:11px">Subtotal</td>
    <td style="font-weight:600">${fmtMoney(subtotal)}</td>
  </tr>
  <tr>
    <td colspan="3" style="text-align:right;color:#6b7280;font-size:11px">Tax (${taxRate}%)</td>
    <td style="color:#6b7280">${fmtMoney(taxAmt)}</td>
  </tr>
  <tr class="tr-total">
    <td colspan="3" style="text-align:right">TOTAL DUE</td>
    <td style="font-size:14px">${fmtMoney(total)}</td>
  </tr>
</table>

<h2>Payment Information</h2>
<div class="highlight">${esc(data['payment_info'] || '')}</div>

<p class="note">Payment is due within 30 days. Late payments are subject to a 1.5% monthly fee. Thank you for your business!</p>

</body>
</html>`;
};
